// Generated by CoffeeScript 2.7.0
var GraphEditor;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import Graph from './graph.js';

export default GraphEditor = Vue.extend({
  props: {
    graph: {
      type: Skylark.App.Model.YetAnotherWorkflow.Graph,
      required: true
    },
    // 私有属性，不可修改，以后可能会改动
    vertexSize: {
      default: function() {
        return {
          width: 150,
          height: 40,
          buffer_width: 3
        };
      }
    }
  },
  components: {
    'graph-editor': Graph
  },
  data: function() {
    return {
      activeGraph: this.graph,
      saving: false,
      zoom: 10
    };
  },
  computed: {
    ancestorGraphs: function() {
      if (!this.activeGraph) {
        return [];
      }
      return this.activeGraph.getAncestors().concat(this.activeGraph);
    },
    btnClass: function() {
      if (this.graph && this.graph.flow && this.graph.flow.status === 'active') {
        return 'btn-danger';
      }
    },
    editorMinWidh: function() {
      var farthest;
      if (!this.activeGraph) {
        return 0;
      }
      farthest = _.max(this.activeGraph.getAllVertices(), function(vertex) {
        return vertex.metadata.position.x;
      });
      return (farthest != null ? farthest.metadata.position.x : void 0) || 0;
    },
    editorMinHeight: function() {
      var farthest;
      if (!this.activeGraph) {
        return 0;
      }
      farthest = _.max(this.activeGraph.getAllVertices(), function(vertex) {
        return vertex.metadata.position.y;
      });
      return (farthest != null ? farthest.metadata.position.y : void 0) || 0;
    },
    editorMinSize: function() {
      return {
        x: this.editorMinWidh,
        y: this.editorMinHeight
      };
    }
  },
  template: `<div class="graph-container" v-if='activeGraph'>
  <div class="breadcrumb">
    <div class='breadcrumb-item'
         v-for='graph in ancestorGraphs'
         :key='graph.id'
         @click='setGraph(graph)'
         :class='{ active: activeGraph === graph }'>
      <span>{{ graph.name || '未命名流程' }}</span>
    </div>
  </div>
  <div class="editor-menu justify-between">
    <div class="left vertical-middle">
      <div class="btn text-btn btn-default menu-item"
           v-if='!activeGraph.isRootGraph()'
           @click='returnToParent'>
        <i class="slp-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="menu-item dragable"
           @mousedown.stop="addVertexBtnMousedownFunc('vertex', $event)">
        <i class="slp-list-square-check-o"></i>
        <span>流程节点</span>
      </div>
      <div class="menu-item dragable"
           @mousedown.stop="addVertexBtnMousedownFunc('automation', $event)">
        <i class="slp-node-robot"></i>
        <span>机器节点</span>
      </div>
      <div class="menu-item dragable"
           @mousedown.stop="addVertexBtnMousedownFunc('child', $event)">
        <i class="slp-dashed-square-o"></i>
        <span>子流程</span>
      </div>
      <div class="actions vertical-middle">
        <div class="btn icon-btn menu-item" @click='deleteSelectedFunc'>
          <i class="slp-trash"></i>
        </div>
        <div class="btn icon-btn menu-item" @click='copyAndPasteSelectedFunc'>
          <i class="slp-copy"></i>
        </div>
        <div class="btn icon-btn menu-item" @click="alginVerticesFunc('vertical')">
          <i class="slp-vertical"></i>
        </div>
        <div class="btn icon-btn menu-item" @click="alginVerticesFunc('horizontal')">
          <i class="slp-horizontal"></i>
        </div>
      </div>
    </div>
    <div class="zoom-controller justify-box">
      <button class="icon-btn" @click="changeZoom(-1)">
        <i class="slp-minus-circle"></i>
      </button>
      <span class="content">{{ zoom * 10 }}%</span>
      <button class="icon-btn" @click="changeZoom(1)">
        <i class="slp-plus-circle"></i>
      </button>
    </div>
    <div class="right vertical-middle">
      <button @click="releaseFlow" :disabled='saving' :class='btnClass'> {{ saving ? '发布中' : '发布' }}</button>
    </div>
  </div>
  <graph-editor :graph='activeGraph'
                ref='editorRef'
                :vertexSize='vertexSize'
                :minSize='editorMinSize'
                :zoom='zoom'
                @enterChildGraph='enterChildGraphFunc'
                @selectedChanged='selectedChangedFunc' />
</div>`,
  methods: {
    releaseFlow: function() {
      var isFirstRelease;
      if (this.saving) {
        return;
      }
      if (this.graph.isValidGraph()) {
        isFirstRelease = this.graph.flow.isFirstRelease();
        if (isFirstRelease) {
          return this.doRelease(isFirstRelease);
        } else {
          return newConfirm({
            title: '流程重新发布后<br>将覆盖现有版本',
            message: '',
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).$on('ensureClicked', () => {
            return this.doRelease(isFirstRelease);
          });
        }
      } else {
        if (this.activeGraph !== this.graph) {
          this.setGraph(this.graph);
        }
        this.reportError(_.first(this.graph._errors));
        return this.saving = false;
      }
    },
    reportError: function(error) {
      switch (error.type) {
        case 'childInvalid':
          if (this.activeGraph !== error.data) {
            this.setGraph(error.data);
          }
          return this.$nextTick(function() {
            if (!this.activeGraph.isValidGraph()) {
              return this.reportError(_.first(this.activeGraph._errors));
            }
          });
        case 'incompleted':
        case 'isolated':
          return newAlertify(error.message, {
            type: 'error'
          });
        case 'circled':
          _.each(error.data, function(vertex) {
            return vertex._status = 'danger';
          });
          _.each(this.activeGraph.getEdgesOfVertices(error.data), function(edge) {
            return edge._status = 'danger';
          });
          return newAlertify(error.message, {
            type: 'error'
          });
      }
    },
    returnToParent: function() {
      if (this.activeGraph.parent) {
        return this.setGraph(this.activeGraph.parent);
      }
    },
    enterChildGraphFunc: function(graph) {
      return this.setGraph(graph);
    },
    setGraph: function(graph) {
      this.activeGraph = graph;
      return this.selectedChangedFunc(this.activeGraph);
    },
    deleteSelectedFunc: function() {
      return this.$refs.editorRef.deleteSelectedFunc();
    },
    copyAndPasteSelectedFunc: function() {
      return this.$refs.editorRef.copyAndPasteSelectedFunc();
    },
    addVertexBtnMousedownFunc: function(type, event) {
      var editor_rect, position;
      if (event.which !== 1) {
        return;
      }
      editor_rect = this.$refs.editorRef.$el.getBoundingClientRect();
      position = {
        x: event.clientX - editor_rect.left - this.vertexSize.width / 2,
        y: event.clientY - editor_rect.top - this.vertexSize.height / 2
      };
      return this.$refs.editorRef.addPreparedVertex(type, position, event);
    },
    alginVerticesFunc: function(dir) {
      return this.$refs.editorRef.alignSelectedVertices(dir);
    },
    selectedChangedFunc: function(active_element) {
      return this.$emit('selectedChanged', active_element);
    },
    doRelease: function(isFirstRelease) {
      this.saving = true;
      return this.graph.flow.release().error((xhr, _error, data) => {
        var attribute, collection_name, graph, id, msg, others, path, vertex;
        // reportErrorsFromServer
        path = _.first(_.keys(data));
        if (!path) {
          return;
        }
        msg = data[path].join(',');
        [collection_name, id, attribute, ...others] = path.split('.');
        id = parseInt(id);
        switch (collection_name) {
          case 'vertices':
            if (vertex = this.graph.flow.findVertexById(id)) {
              vertex._status = 'danger';
              this.setGraph(vertex.graph);
              this.$nextTick(function() {
                return this.$refs.editorRef.focusVertexFunc(vertex);
              });
              newAlertify(vertex.name + '：' + Skylark.Helpers.getZH_CN(`yaw.vertices.${attribute}`) + msg, {
                type: 'error'
              });
              return;
            }
            break;
          case 'graphs':
            if (graph = this.graph.flow.findGraphById(id)) {
              this.setGraph(graph);
              newAlertify(`${graph.name}：${msg}`, {
                type: 'error'
              });
              return;
            }
        }
        return newAlertify("发布失败", {
          type: 'error'
        });
      }).success(function() {
        newAlertify("发布成功", {
          type: 'success'
        });
        if (isFirstRelease) {
          return window.location.reload();
        }
      }).complete((xhr) => {
        return this.saving = false;
      });
    },
    changeZoom: function(delta) {
      return this.zoom = Math.max(5, Math.min(15, this.zoom + delta));
    }
  }
});
